import React, { useState, useEffect} from "react";
import { onAuthStateChanged } from "firebase/auth";
import { useNavigate } from "react-router-dom";

// --- CSS --- //
import "../styles/login.css"; // Ensure this imports the correct CSS for climbing holds without animation

// --- Assets --- //
import logo from "../assets/vert-cert-logo.png";
import HomeIcon from '@mui/icons-material/Home';

// --- FIREBASE --- //
import { handleLogin } from "../utilities/auth/authUtils";
import { auth } from "../firebase"; // Make sure to import your auth object from Firebase

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    // Check if user is already logged in when the component mounts
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        // Get user token and role
        const idTokenResult = await user.getIdTokenResult();
        const userRole = idTokenResult.claims.role || "public"; // Default to 'public' if no role is set

        // Redirect based on the user's role
        if (userRole === "gymAccess") {
          navigate("/certify"); // Redirect to Gym Dashboard
        } else if (userRole === "user") {
          navigate("/my-profile"); // Redirect to User Profile
        }
      }
    });

    // Cleanup the subscription on component unmount
    return () => unsubscribe();
  }, [navigate]);

  const onLoginSubmit = (e) => {
    e.preventDefault();
    handleLogin(email, password, navigate, setError);
  };

  return (
    <div className="login-page">
      <div className="login-window">
        <a href="/"><img src={logo} alt="Vert Cert Logo" className="logo" /></a>
        <a href="/" className="home-link"><HomeIcon /></a>
        
        <h2 className="login-title">Login</h2>
        {error && <p className="error-message">{error}</p>}
        <form onSubmit={onLoginSubmit}>
          <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          <button type="submit">Login</button>
        </form>

        {/* Forgot password and Sign up link */}
        <div className="forgot-password">
          <a href="/forgot-password">Forgot Password?</a>
        </div>
        <div className="sign-up">
          <p>Don't have an account?</p>
          <a href="/sign-up" className="signup-link">Sign Up</a>
        </div>
      </div>
    </div>
  );
};

export default Login;